export default "/img/RO.83a319059edbff6f378aabc7364eeed6.png";